export const Spinner = ({ width = 20 }) => {
    return (
        <div className="sp-spinner-container" style={{ width: width, height: width }}></div>
    )
}